const AccessibleText = ({
	children,
	role = null,
	ariaLevel = null,
	ariaLive = null,
	text,
}) => {
	return (
		<span
			role={role}
			aria-level={ariaLevel}
			aria-live={ariaLive}
			className="syndicated-accessible-text"
		>
			{children}
		</span>
	);
};

export default AccessibleText;
